import React from 'react'
import styled from 'styled-components'
import theme from 'stories/utils/theme'
import { Body2 } from 'stories/elements/Typography/Text'
import _useTranslation from 'lib/hooks/_useTranslation'

const AssetWrapper = styled.div`
    width: 350px;
    height: 380px;
    border-radius: 24px;
    background: linear-gradient(180deg, #0f1e0c 0%, #051f1b 100%);
    position: relative;
    box-shadow: 0px 12px 24px 0px #00000033, 0px 36px 36px 0px #0bd0bd80;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 28px 0;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 24px;
        padding: 5px;
        background: linear-gradient(180deg, #5ed062 0%, #0bd0bd 100%);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
    }
    @media (max-width: 860px) {
        width: 300px;
        height: 325px;
        border-radius: 20px;
        padding: 24px 0;
        &::before {
            border-radius: 20px;
        }
    }
`

const CardStack = styled.div`
    position: relative;
    width: 326px;
    height: 370px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    @media (max-width: 860px) {
        width: 280px;
        height: 316px;
    }
`

const Card = styled.div<{ index: number }>`
    width: 286px;
    height: 129px;
    border-radius: 14px;
    background: linear-gradient(180deg, #50b354 0%, #439746 100%);
    position: relative;
    margin-bottom: -11px;
    transform: rotate(
        ${(props) => {
            if (props.index === 0) return -6
            if (props.index === 1) return 3
            return -3
        }}deg
    );
    box-shadow: 0px 5px 20px 0px #00000080;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${(props) => 3 - props.index};
    padding: 10px;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 14px;
        padding: 1.5px;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%);
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
    }

    @media (max-width: 860px) {
        width: 245px;
        height: 110px;
        border-radius: 12px;
        margin-bottom: -9px;

        &::before {
            border-radius: 12px;
        }
    }
`

const CardText = styled(Body2)`
    font-family: var(--font-inter);
    font-size: 16px !important;
    font-weight: 650;
    text-align: center;
    max-width: 256px;
    word-wrap: break-word;

    @media (max-width: 860px) {
        font-size: 16px;
        max-width: 220px;
    }
`

const FlashcardsAsset: React.FC = () => {
    const { t } = _useTranslation('homepage')

    const cards = [
        { text: t('homepage/flashcardItem1'), index: 0 },
        { text: t('homepage/flashcardItem2'), index: 1 },
        { text: t('homepage/flashcardItem3'), index: 2 },
    ]

    return (
        <AssetWrapper>
            <CardStack>
                {cards.map((card) => (
                    <Card key={card.index} index={card.index}>
                        <CardText color={theme.colors.white} fontFamily="var(--font-inter)">
                            {card.text}
                        </CardText>
                    </Card>
                ))}
            </CardStack>
        </AssetWrapper>
    )
}

export default FlashcardsAsset
